import React, { useContext, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { CustomValidatedDefaultBid } from '@bingads-webui-campaign-react/default-bid';
import { Label } from '@fluentui/react';
import { HelpPopup } from '@bingads-webui-react/help-popup';

export const PriceModelToRange = {
  ManualCpa: 'KeywordBidRange',
  ManualCpc: 'KeywordBidRange',
};

export const ValidatedBidValue = ({
  validationProps,
  onBidChange,
}) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);

  const { data: campaign, bidValueType } = validationProps || {};

  const { BiddingScheme } = campaign;

  const getBidRange = useCallback((type) => {
    const bidCeil = _.result(serverContext[PriceModelToRange[type]], 'CeilingValue');
    const bidFloor = _.result(serverContext[PriceModelToRange[type]], 'FloorValue');

    return { bidCeil, bidFloor };
  }, [serverContext]);

  const SearchBid = useCallback(() => {
    const { bidCeil, bidFloor } = getBidRange(BiddingScheme.Type);

    return (
      <CustomValidatedDefaultBid
        placeholderText="5.00"
        id="input-bid"
        currencyCode={serverContext.CurrentAccount.CurrencyCode}
        i18n={i18n}
        validationProps={{
          field: bidValueType,
          schema: {
            properties: {
              [bidValueType]: {
                type: 'number',
                minimum: bidFloor,
                maximum: bidCeil,
                required: true,
              },
            },
          },
        }}
        onBidChange={onBidChange}
      />
    );
  }, [getBidRange, i18n, BiddingScheme, serverContext.CurrentAccount.CurrencyCode, bidValueType, onBidChange]);

  return (
    <div>
      <Label htmlFor="input-bid">
        {i18n.getString(_TL_('Default bid'))}
        <HelpPopup
          topic="pop_BA_BidTypeAwareness"
          aria-label={i18n.getString(_TL_('Click to learn more about bid strategy'))}
        />
      </Label>
      <SearchBid />
    </div>
  );
};

ValidatedBidValue.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      campaign: PropTypes.shape({}).isRequired,
      bidValueType: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onBidChange: PropTypes.func.isRequired,
};

